import { createAsyncThunk } from '@reduxjs/toolkit';

import { APIDataProvider, ApiPaths, TApiResponse } from '../../api';
import { IProgress, ISubjectForProgress } from '.';

interface ISaveProgress {
  subTopicId: string;
  quizCompletion?: boolean;
  practiceQuestionCompletion?: boolean;
  videoCompletion?: boolean;
  resource?: { total: number; completed: number };
  practiceQuestion?: { attempted: number; correct: number };
}

interface IGetSubjectProgress {
  curriculum: string;
  subject: string;
  subjectLevel: string;
}

const apiDataProvider = new APIDataProvider();

export const saveStudentProgress = createAsyncThunk(
  'user/progress/save',
  async (data: ISaveProgress) => {
    const response = await apiDataProvider.post<TApiResponse<IProgress>>(
      `${ApiPaths.progress}`,
      data
    );

    return response.data;
  }
);

export const getStudentProgress = createAsyncThunk(
  'user/progress/get',
  async (subTopicId: string) => {
    const response = await apiDataProvider.get<TApiResponse<IProgress>>(
      `${ApiPaths.progress}/${subTopicId}`
    );

    return response.data;
  }
);

export const getSubjectProgress = createAsyncThunk(
  'user/progress/getSubjectProgress',
  async (data: IGetSubjectProgress) => {
    const response = await apiDataProvider.post<
      TApiResponse<ISubjectForProgress>
    >(`${ApiPaths.progress}/getSubjectProgress`, data);

    return response.data;
  }
);
